<template>
  <div>
    <div>
      <landing-page-nav></landing-page-nav>
    </div>
    <div class="sec-1">
      <div class="sec-1-child-right">
        <img
          class="main-image"
          src="@/assets/images/LandingPageImage.png"
          alt="Covesto - building the community investing ecosystem for new age investors"
        />
      </div>
      <div class="sec-1-child-left">
        <h2 style="text-transform: capitalize">
          Individual investing to community covesting
        </h2>
        <p>Building the community investing ecosystem for new age investors</p>
        <v-btn color="#2D8CFF" class="get-started-btn" :to="{ name: 'login' }">
          Get started</v-btn
        >
      </div>
    </div>
    <div class="sec-2">
      <h1 class="about-text">About Covesto</h1>
      <div class="sec-2-child">
        <div class="sec-2-right-img">
          <v-carousel
            class="image-carousel"
            cycle
            height="auto"
            :show-arrows="false"
          >
            <v-carousel-item
              v-for="(item, i) in items"
              :key="i"
              class="carousel-img"
              :src="item.src"
              reverse-transition="fade-transition"
              fade
            ></v-carousel-item>
          </v-carousel>
        </div>
        <div class="sec-2-left-text">
          <p class="sec-2-child-text">
            A knowledge-sharing platform for
            <span style="color: #2d8cff"> Investors</span> and
            <span style="color: #2d8cff">Experts</span>. Share your experience,
            learn from experts, invest smarter
          </p>
          <ul>
            <li class="li-ele">
              Follow experts, see recommendations, real-time follow-up, all in
              one place.
            </li>
            <li class="li-ele">
              Find credible like-minded investors who you can trust.
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="sec-4">
      <Footer class="footer" />
    </div>
  </div>
</template>

<script>
import Footer from "./Footer.vue";

export default {
  components: {
    Footer,
    LandingPageNav: () => import("./LandingpageNav.vue"),
  },
  name: "LandingPage",

  metaInfo: {
    title: "Covesto",
    titleTemplate: null,
  },

  data() {
    return {
      items: [
        {
          src: require("@/assets/images/home_mockups/Mockup_one.png"),
        },
        {
          src: require("@/assets/images/home_mockups/Mockup_two.png"),
        },
        {
          src: require("@/assets/images/home_mockups/Mockup_three.png"),
        },
        {
          src: require("@/assets/images/home_mockups/Mockup_four.png"),
        },
      ],
    };
  },

  mounted() {
    this.$store.state.Auth.checkStatus = "LANDING";
    this.$store.state.Auth.isPrivate = false;
    this.$logEvent("landing_page_view");
    if (this.$vuetify.breakpoint.xsOnly) {
      this.$logEvent("mweb_landing_page_view");
    }
  },
};
</script>

<style>
.v-carousel__controls {
  background: #f3f6fb !important;
}
.v-carousel__controls__item {
  color: #6c9dfd !important;
}
</style>

<style scoped>
.sec-1-child-right {
  margin: auto auto;
}
.main-image {
  height: 250px !important;
  width: 340px !important;
  padding: 10px auto;
  margin: 5px auto;
}

.sec-1 {
  flex-direction: column;
}
.sec-1,
.sec-3 {
  display: flex;
  min-height: 50vh;
  text-align: center;
  flex-direction: column;
  padding: 10px auto;
}
h2 {
  margin: 10px 20px !important;
  font-size: 20px;
  font-weight: bolder;
}
p {
  font-size: 15px;
  word-wrap: break-word;
  color: rgba(51, 51, 51, 0.92);
  margin: 10px 20px !important;
}
.get-started-btn {
  margin: 10px 20px;
  height: 45px;
  font-size: 15px;
  font-weight: bolder;
  color: #fff;
  letter-spacing: 0px;
  text-transform: capitalize;
}
.sec-2 {
  text-align: center;
  min-height: 50vh;
  background-color: #f3f6fb !important;
}
.about-text {
  font-size: 20px;
  padding-top: 50px;
}
.image-carousel {
  width: 300px;
  margin: 5px auto;
  height: 300px !important;
}
.carousel-img {
  object-fit: cover !important;
}
ul {
  list-style-type: none;
  text-align: left;
  display: table;
  counter-reset: foo;
  list-style-position: outside !important;
  flex-direction: column;
  cursor: text;
  font-size: 15px;
}
ul li {
  cursor: text;
  list-style-position: outside !important;
  text-align: left;
  padding: 10px 40px !important;
  list-style-position: inside;
  text-indent: -1.6em;
  padding-left: 4em;
  font-size: 15px;

  color: rgba(51, 51, 51, 0.84);
}
.sec-2-child-text {
  text-align: left;
  padding: 0px 20px;
}
ul li:before {
  /* the custom styled bullets */
  border-radius: 10%;
  content: "";
  display: inline-block;
  margin-right: 10px;
  margin-bottom: 2px;
  height: 10px;
  width: 10px;
  background: #6c9dfd;
  transform: rotate(-45deg);
}
.team-text {
  font-size: 20px;
  padding-top: 20px;
}
.team-para-text {
  line-height: 1.5;
  text-align: left;
  padding: 20px;
  justify-content: center;
}
.team-img {
  width: 150px;
  height: 150px;
  margin: 20px;
}
.sec-4 {
  min-height: 50px;
  background-color: #f3f6fb;
}

.team-name {
  font-size: 15px;
  font-weight: bold;
  margin: 0px !important;
  cursor: pointer;
}

@media all and (min-width: 1300px) {
  .sec-1 {
    min-height: 80vh;
    flex-direction: row-reverse;
  }

  .sec-1-child-left {
    margin: 200px 50px;
    text-align: left;
  }
  .main-image {
    margin-top: 0px !important;
    padding-top: 0px !important;
    height: 500px !important;
    width: 700px !important;
  }
  h2 {
    font-size: 50px;
    font-weight: bolder !important;
  }
  p {
    font-size: 18px;
  }
  .get-started-btn {
    width: 200px;
    height: 50px !important;
  }
  .about-text,
  .team-text {
    font-weight: bolder;
    font-size: 34px;
  }
  .sec-2-child {
    display: flex;
    padding: 20px 50px;

    flex-direction: row-reverse;
  }
  .carousel-img {
    object-fit: contain !important;
  }
  .image-carousel {
    width: 700px !important;
    margin: 5px auto;
    height: 600px !important;
  }
  .carousel-img {
    height: 600px;
    object-fit: cover !important;
    width: 700px;
  }
  .sec-2-left-text {
    padding: 80px 20px;
    text-align: left;
  }
  .sec-2-child-text {
    text-align: left;
    margin: 10px 5px 50px 5px !important;
  }
  .ul li {
    margin: 10px 20px !important;
    font-size: 18px !important;
  }
  .sec-3-child-div {
    display: flex;
    text-align: center;
    margin: 10px auto;
  }
  .team-text {
    padding-top: 50px;
  }
  .team-para-text {
    text-align: center;
    padding: 20px 100px;
  }
  .sec-3-child-div {
    margin-top: 20px;
  }
  .team-img {
    height: 150px;
    width: 150px;
    margin-right: 50px;
  }
  .team-name {
    padding-right: 40px !important;
  }
  .li-ele {
    font-size: 16px;
    padding: 15px 40px;
  }
}

@media all and (min-width: 1500px) {
  .sec-2-left-text {
    padding: 130px 100px;
  }
  ul li {
    font-size: 17px;
  }
  .team-text {
    padding-top: 50px;
  }
  .team-para-text {
    text-align: center;
    padding: 20px 100px;
  }
  .sec-3-child-div {
    margin-top: 20px;
  }
  .team-img {
    height: 150px;
    width: 150px;
    margin-right: 50px;
    cursor: pointer;
  }
}
</style>
